import { useFlowPicker } from 'apps/flowPicker/hooks/useFlowPicker'
import { FlowPickerSource } from 'apps/flowPicker/lib/constants'

interface FlowPickerSubscriberProps {
  onSelect: (flowId: string) => void
  onCreate?: () => void
  source: FlowPickerSource
}

export const FlowPickerSubscriber = ({ onSelect, onCreate, source }: FlowPickerSubscriberProps) => {
  useFlowPicker({ source, onFlowSelect: onSelect, onFlowCreate: onCreate })

  return null
}
